import { Text } from '@joor/design-system'
import classNames from 'classnames'
import styled from 'styled-components'

import {
  AccountInfo,
  AccountInfoType,
} from 'features/Shared/components/AccountInfo/AccountInfo'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const AccountWrapper = styled.div`
  border: 1px solid var(--color-primary-200);
  border-radius: 10px;
  padding: 10px;
  width: 370px;
  margin-bottom: 6px;
  &.disabled {
    color: var(--color-primary-400);
    border: 1px solid var(--color-primary-400);
  }
  &.primary {
    border: 1px solid var(--color-accent-beta-700);
  }
`

export interface AccountOptionType extends AccountInfoType {
  showPrimaryFooterText?: boolean
  isOwner?: boolean
  isCurrentLoggedAccount?: boolean
}

export const AccountOption = ({
  accountName,
  connectedAccounts = [],
  showCheckMarkIcon = false,
  isPrimary,
  showPrimaryFooterText = false,
  createdAt,
  privacy,
  hideVisibilityIcon = false,
  createdBy,
  disabled = false,
}: AccountOptionType) => {
  return (
    <Wrapper>
      <AccountWrapper
        data-testid="account-option"
        className={classNames({
          disabled: disabled,
          primary: !disabled && isPrimary,
        })}
      >
        <AccountInfo
          accountName={accountName}
          isPrimary={isPrimary}
          showCheckMarkIcon={showCheckMarkIcon}
          createdBy={createdBy}
          createdAt={createdAt}
          connectedAccounts={connectedAccounts}
          hideVisibilityIcon={hideVisibilityIcon}
          privacy={privacy}
          disabled={disabled}
        />
      </AccountWrapper>
      {showPrimaryFooterText && (
        <Text fontFamily="alpha" fontSize="extrasmall" color="primary-400">
          Primary accounts are always visible to all brands
        </Text>
      )}
    </Wrapper>
  )
}
